document.addEventListener('DOMContentLoaded', function() {
  const gridSwitchers = document.querySelectorAll('.grid__switcher');

  gridSwitchers.forEach(button => {
    button.addEventListener('click', () => {
      // Look up the grid container fresh on every click instead of caching
      // it once at page load. Shopify's facets.js (filtering / sorting)
      // replaces #ProductGridContainer's innerHTML on every filter/sort
      // interaction, which destroys and recreates the .collection__grid
      // node. A reference cached at DOMContentLoaded goes stale the moment
      // that happens, so the switcher silently stops updating anything
      // after the shopper has filtered or sorted at least once.
      const productLayout = document.querySelector('.collection__grid');
      if (!productLayout) return;

      gridSwitchers.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      if (button.classList.contains('grid__two')) {
        productLayout.setAttribute('data-mobile-cols', '2');
        // Keep the render-time single-column class (added by Liquid when
        // the section's default mobile setting is '1') in sync with the
        // live toggle so the switch works regardless of that default.
        productLayout.classList.remove('collection__grid-single');
      } else if (button.classList.contains('grid__one')) {
        productLayout.setAttribute('data-mobile-cols', '1');
        productLayout.classList.add('collection__grid-single');
      }
    });
  });
});
